<div [ngStyle]="!tree.isLoading && infoBoxes?.first?.boxesExist && { 'position': 'relative', 'right': '8em' }">
  <div class="item-header-section" *ngIf="!optional">

    <!-- ======================================= header line (VAT / currency / price date / discount / partial payment) ======================================== -->

    <div style="width:7em;margin-right:2em">
      <div style="flex:1; font-weight: bold">Line Items</div><br>
      <div *ngIf="data.visibleMap.vat">
        Global VAT:&nbsp;
        <ngx-doc-form-dropdown [(value)]="compilation.vatGlobal" [options]="vatPercentOptions" [disabled]="disabled" (valueChange)="onVatGlobalChanged($event)">
        </ngx-doc-form-dropdown>
      </div>
    </div>
    <div *ngIf="data.visibleMap.prices" style="width:11em">
      Global Currency:&nbsp;
      <ngx-doc-form-dropdown [(value)]="compilation.currency" [options]="currencyOptions" [disabled]="disabled" (valueChange)="onCurrencyChanged()">
      </ngx-doc-form-dropdown>
    </div>
    <span style="flex:1" class="price-date">PriceDate<ngx-doc-form-date [(value)]="$any(this).priceDate" [disabled]="disabled"></ngx-doc-form-date></span>
    <div *ngIf="data.visibleMap.discount && !isPartialPayment()" style="width:15em">
      Discount:&nbsp;
      <ngx-doc-form-texfield [disabled]="disabled" [styles]="invoicePercentStyle" [(value)]="$any(compilation).discount" (valueChange)="onDiscountChanged($any($event))"></ngx-doc-form-texfield> %
    </div>
    <div *ngIf="data.visibleMap.invoicePayment && isPartialPayment()" style="width:15em">
      Partial payment:&nbsp;
      <ngx-doc-form-texfield [(value)]="$any(compilation).invoicePercent" [disabled]="disabled" [styles]="invoicePercentStyle" (valueChange)="onInvoicePercentChanged($any($event))"></ngx-doc-form-texfield> %
    </div>
    <!-- <div *ngIf="['TOF', 'OF'].includes(typeData.get(compilation.type).code) && !disabled"> -->
    <div *ngIf="!disabled">
      <button class="nrk-button mr-2" title="update all finished products" (click)="updateFinishedProduct()">update FPs</button>
    </div>
    <div *ngIf="!disabled">
      <button class="nrk-button mr-2" title="generate all line items from base product" (click)="generateProduct(-1)">gen from base product</button>
    </div>
    <div *ngIf="!disabled" style="margin:0">
      <!-- <button *ngIf="!disabled && data.visibleMap.transferPrices" class="nrk-button" (click)="transferAllPrices()">transfer prices to matrix</button> -->
      <button style="margin-top:0.3em" class="nrk-button" (click)="updateAllPrices()">update prices from matrix</button>
    </div>
    <div *ngIf="disabled" style="width:15rem;">&nbsp;</div>
  </div>

  <div *ngIf="optional">
    <br><br>
    <b>Optional Line Items</b><br>
  </div>

  <!-- ========================================================= line items ========================================================= -->

  <div class="item-section">
    <table>

      <!-- line item header -->
      <tr>
        <th>
          <ng-container *ngIf="compilation.vatGlobal != null">
            <button *ngIf="!disabled" class="nrk-button" alt="Add position" title="Add item" (click)="onNewLineItem()">+</button>
          </ng-container>
          <ng-container *ngIf="compilation.vatGlobal == null">
            <button *ngIf="!disabled" [nbPopover]="vatPopoverRef" class="nrk-button" alt="Add position" title="Add item">+</button>
            <ng-template #vatPopoverRef>
              <div class="global-vat">
                You have to enter the global VAT<br>before you can add an item
                <ul><li>Global VAT:</li><li *ngFor="let vat of vatPercentOptions" class="pseudo-link" (click)="compilation.vatGlobal = vat.id;onNewLineItem()">{{vat.name}}</li></ul>
              </div>
            </ng-template>
          </ng-container>
        </th>
        <th style="min-width:530px;">Description</th>
        <th style="max-width:60px;">Quantity</th>
        <th style="max-width:30px;">Unit</th>
        <th *ngIf="data.visibleMap.prices" style="max-width:60px;">Price/Unit</th>
        <th *ngIf="data.visibleMap.prices" style="text-align:right">Net</th>
        <th *ngIf="data.visibleMap.vat">VAT%</th>
        <th *ngIf="data.visibleMap.grossWeight">GW</th>
        <th *ngIf="!disabled">⬍</th>
      </tr>

      <tbody *ngFor="let item of lineItems; let idx = index; last as isLast">

        <ng-template #priceMatrixRef>
          <ng-container *ngIf="!item.matrixPriceItem?.price?.length" [ngSwitch]="true">
            <div class="p-2" *ngSwitchCase="checkPriceFromDate(item, 'dateOfDelivery')">no customer requested delivery date set</div>
            <div class="p-2" *ngSwitchCase="checkPriceFromDate(item, 'dateOfDispatch')">no dispatch date set</div>
            <div class="p-2" *ngSwitchDefault>no price in price matrix</div>
          </ng-container>
          <table *ngIf="item.matrixPriceItem?.price" class="table">
            <tr><th>Price</th><th>Unit</th><th>Valid from</th><th>Valid to</th><th>Price/pc</th></tr>
            <tr *ngFor="let price of item.matrixPriceItem.price.slice(0,3)">
              <td style="text-align: right">{{price.value | currency : price.currency : 'symbol' : '1.3-3' : 'de'}}</td>
              <td>{{price.type | priceUnit : false}}</td>
              <td>{{price.validFrom | date : 'yyyy-MM-dd'}}</td>
              <td>{{price.validTo | date : 'yyyy-MM-dd'}}</td>
              <td style="text-align: right">{{$any(price).piecePrice | currency : price.currency : 'symbol' : '1.3-3' : 'de'}}</td>
            </tr>
          </table>
        </ng-template>

        <tr *ngIf="!tree.isLoading && data.visibleMap.prices && checkInvalidPrices(item, idx) && invalidPriceItems[idx]?.length">
          <td colspan="100" style="background-color:#f009; padding:0.2rem 1rem;">
            <div *ngFor="let val of Object.values(invalidPriceItems[idx] ?? {})">
              {{val[1]}}
            </div>            
          </td>
        </tr>

        <tr style="vertical-align: top">

          <!-- POS -->
          <td>{{$any(item).position.posOverride || (data.getPositionNumberFormat(compilation) | printf : idx + 1)}}
            <div style="position:relative; left:70em; bottom: 1.5em" *ngIf="['OF'].includes(typeData.get(compilation.type)?.code)">
              <div style="position: absolute">
                <ngx-line-item-info-box #infoBox [compilation]="compilation" [lineItem]="item"></ngx-line-item-info-box>
              </div>
            </div>
            <div style="position:relative">
              <div *ngIf="item?.finishedProduct?.disabled" style="position:absolute;left:-10rem;top:3rem;padding:0.5rem;background-color:white;border-radius:15px">

                <!-- <div *ngIf="item?.finishedProduct?.disabled"> -->
                  ⚠️ FP disabled ⚠️
                <!-- </div> -->
              </div>
              <div *ngIf="!disabled" style="position:absolute;left:-3rem">
                <button class="nrk-button" (click)="cloneLineItem(item, idx)" title="Clone Line Item"><nb-icon icon="copy-outline"></nb-icon></button>
              </div>
            </div>
          </td>

          <!-- finished product -->
          <td style="text-align:left" class="product-select">
            <div class="product-select-input">
              <ngx-doc-form-texfield class="fullwidth" placeholder="Product name" [(value)]="item.productName" [disabled]="disabled">
              </ngx-doc-form-texfield>
            </div>
            <div *ngIf="!disabled" class="product-select-button mr-2">
              <!-- <ngx-form-column-select [value]="'o'" [business]="mongoId(compilation.recipient)" [compilation]="compilation" (productSelected)="onProductSelected(idx, $event)">
              </ngx-form-column-select> -->
              <ngx-document-finished-product-selector
                [style]="{'left':'-35em','width':'65em'}"
                [businessId]="mongoId(compilation.recipient)"
                (compilationChange)="onProductSelected(idx, $event)"
              >
              </ngx-document-finished-product-selector>
            </div>
            <div *ngIf="!disabled">
              <button class="nrk-button" (click)="generateProduct(idx)" title="generate product">gen</button>
            </div>
          </td>

          <!-- quantity in pieces -->
          <td>
            <ngx-doc-form-texfield class="fullwidth right" placeholder="Quantity pcs" [mode]="'float'"
            [(value)]="$any(item).quantity" (valueChange)="recalc()" [disabled]="true"></ngx-doc-form-texfield>
          </td>

          <!-- pieces -->
          <td class="text-center" style="display:flex">
              <button 
                class="nrk-button mr-1" 
                (click)="openLineItemMetrics(item)"
              >pc</button>
              <button *ngIf="item.piecePrice === item.calculatedPiecePrice" class="nrk-button" (click)="showRoundedPrice(item, true)" [disabled]="disabled">≈</button>
              <button *ngIf="item.piecePrice !== item.calculatedPiecePrice" class="nrk-button" (click)="showRoundedPrice(item, false)" [disabled]="disabled">≇</button>
          </td>

          <!-- price / piece -->
          <td *ngIf="data.visibleMap.prices">
            <div [nbPopover]="priceMatrixRef" nbPopoverTrigger="hover" 
                [ngStyle]="{'border': invalidPriceItems[idx]?.length ? '4px solid red' : null}"
                [ngClass]="{'deprecated-remove------wrong-price': item.matrixPiecePrice === null || ( item.matrixPiecePrice !== undefined && (item.matrixPiecePrice | ngxRound : 3) !== (item.piecePrice | ngxRound : 3))}">
                  <ngx-doc-form-texfield *ngIf="item.piecePrice !== item.calculatedPiecePrice" class="fullwidth right" placeholder="Price/pc" mode="currency" format="1.3-3" [currency]="compilation.currency"
                [(value)]="$any(item).piecePrice" (valueChange)="recalc()" [disabled]="true"></ngx-doc-form-texfield>
                  <ngx-doc-form-texfield *ngIf="item.piecePrice === item.calculatedPiecePrice" class="fullwidth right" placeholder="Price/pc" mode="currency" format="1.3-10" [currency]="compilation.currency"
                [(value)]="$any(item).piecePrice" (valueChange)="recalc()" [disabled]="true"></ngx-doc-form-texfield>
            </div>
            <div *ngIf="item.calculatedPiecePrice && item.calculatedPiecePrice !== item.piecePrice" class="calculated-price"><div>{{item.calculatedPiecePrice | ngxRound : 10}}</div></div>
            <!-- legacy: -->
            <div *ngIf="!item.calculatedPiecePrice && (item.piecePrice | ngxRound : 3) !== (item.piecePrice | ngxRound : 10)" class="calculated-price"><div>{{item.piecePrice | ngxRound : 10}}</div></div>
            <!-- <div *ngIf="isInvalidPrice(item)." [ngStyle]="{'color':'red','font-size':'10px'}">Price date !</div>
            <div *ngIf="isInvalidPrice(item)" [ngStyle]="{'color':'red','font-size':'10px'}">Price value !</div> -->
            <!-- <div *ngFor="let val of Object.values(invalidPriceItems[idx] ?? {})" [ngStyle]="{'color':'red','font-size':'10px','text-align':'center'}" [title]="val[1]">
              {{val[0]}}
            </div> -->
          </td>

          <!-- net price -->
          <td *ngIf="data.visibleMap.prices" style="text-align:right">
            {{(item.quantity*item.piecePrice) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
            <div *ngIf="item.calculatedPiecePrice && item.calculatedPiecePrice !== item.piecePrice" class="calculated-price"><div>{{item.quantity * item.calculatedPiecePrice | ngxRound : 10}}</div></div>
            <!-- legacy: -->
            <div *ngIf="!item.calculatedPiecePrice && (item.piecePrice | ngxRound : 3) !== (item.piecePrice | ngxRound : 10)" class="calculated-price"><div>{{(item.quantity * (item.piecePrice | ngxRound : 3) | ngxRound : 10)}}</div></div>
          </td>

          <!-- VAT -->
          <td *ngIf="data.visibleMap.vat" [ngClass]="{'vat-highlight': compilation.vatGlobal != item.VATPercent}">
            <ngx-doc-form-dropdown class="fullwidth" [(value)]="item.VATPercent" [options]="vatPercentOptions"
              (valueChange)="recalc()" [disabled]="disabled"></ngx-doc-form-dropdown>
          </td>

          <!-- gross weight -->
          <td *ngIf="data.visibleMap.grossWeight">
            <div class="row" style="width:7em">
              <div><ngx-doc-form-texfield [styles]="{width:'4em'}" class="right mr-2" placeholder="Gross weight"format="1.0-2" [(value)]="$any(item).weight" [disabled]="disabled"></ngx-doc-form-texfield></div>
              <div>kg</div>
            </div>
          </td>

          <!-- move handles -->
          <td *ngIf="!disabled" rowspan="5">
            <table>
              <tr *ngIf="typeData.get('OF').id === compilation.type">
                <td *ngIf="optional" class="moveItem" (click)="onOptionalToLineItem(idx, true)" title="move to line items">↟</td>
              </tr>
              <tr>
                <td *ngIf="idx == 0" class="moveItemDisabled">▲</td>
                <td *ngIf="idx !== 0" class="moveItem" (click)="onMoveLineItem(idx, true)" title="move item up">▲</td>
              </tr>
              <tr>
                <td *ngIf="isLast" class="moveItemDisabled">▼</td>
                <td *ngIf="!isLast" class="moveItem" (click)="onMoveLineItem(idx, false)" title="move item down">▼</td>
              </tr>
              <tr *ngIf="typeData.get('OF').id === compilation.type">
                <td *ngIf="!optional" class="moveItem" (click)="onOptionalToLineItem(idx, false)" title="move to optional line items">↡</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="width:3rem"><ngx-doc-form-texfield class="fullwidth" placeholder="Pos" 
              [(value)]="$any(item).position.posOverride" [disabled]="disabled">
            </ngx-doc-form-texfield>
          </td>

          <!-- attribute remark / attribute code (2nd line) -->
          <td>
            <table><tr><td style="max-width: 40em">
              <!-- <ngx-doc-form-texfield class="fullwidth" placeholder="Customer product name or empty"
              [(value)]="item.attributeRemark" [disabled]="disabled"></ngx-doc-form-texfield> -->
              <ngx-form-text [multiline]="1" [(value)]="item.attributeRemark"  placeholder="Customer product name or empty" [disabled]="disabled"></ngx-form-text>
            </td><td>
              <!-- <ngx-doc-form-texfield class="fullwidth" placeholder="Customer product code or empty"
              [(value)]="item.attributeCode" [disabled]="disabled"></ngx-doc-form-texfield> -->
              <ngx-form-text [multiline]="1" [(value)]="item.attributeCode"  placeholder="Customer product code or empty" [disabled]="disabled"></ngx-form-text>
            </td></tr></table>
          </td>

          <!-- quantity per unit -->
          <td>
            <ngx-doc-form-texfield class="fullwidth right" placeholder="Quantity" [mode]="'float'" 
              [(value)]="$any(item).displayUnitQuantity" (valueChange)="recalc()" [disabled]="true">
            </ngx-doc-form-texfield>
          </td>

          <!-- unit -->
          <td *ngIf="item.displayUnit">
            <ngx-doc-form-texfield class="fullwidth center" [(value)]="unitData.get(item.displayUnit).short" [disabled]="true">
            </ngx-doc-form-texfield>
          </td>

          <!-- price / unit -->
          <td *ngIf="data.visibleMap.prices">
            <div [nbPopover]="priceMatrixRef" nbPopoverTrigger="hover"
                [ngClass]="{'deprecated-remove--------wrong-price': item.matrixPiecePrice === null || ( item.matrixPiecePrice !== undefined && (item.matrixPiecePrice | ngxRound : 7) !== (item.piecePrice | ngxRound : 7))}">
            <ngx-doc-form-texfield *ngIf="item.piecePrice !== item.calculatedPiecePrice" class="fullwidth right" placeholder="Price" mode="currency" format="1.3-7" [currency]="compilation.currency"
                [(value)]="$any(item).displayUnitPrice" [disabled]="true"></ngx-doc-form-texfield>
            <ngx-doc-form-texfield *ngIf="item.piecePrice === item.calculatedPiecePrice" class="fullwidth right" placeholder="Price" mode="currency" format="1.3-10" [currency]="compilation.currency"
                [(value)]="$any(item).displayUnitPrice" [disabled]="true"></ngx-doc-form-texfield>
            </div>
            <div *ngIf="(item.displayUnitPrice | ngxRound : 7) !== (item.displayUnitPrice | ngxRound : 10)" class="calculated-price"><div>{{item.displayUnitPrice | ngxRound : 10}}</div></div>
          </td>

          <td *ngIf="data.visibleMap.prices">
            <div *ngIf="(item.displayUnitPrice | ngxRound : 7) !== (item.displayUnitPrice | ngxRound : 10)" class="calculated-price">{{(item.displayUnitPrice | ngxRound : 7) * item.displayUnitQuantity}}</div>
            <div *ngIf="(item.displayUnitPrice | ngxRound : 7) !== (item.displayUnitPrice | ngxRound : 10)" class="calculated-price"><div>{{(item.displayUnitPrice * item.displayUnitQuantity) | ngxRound : 10}}</div></div>
          </td>
          <td *ngIf="data.visibleMap.vat"></td>
          <td *ngIf="data.visibleMap.grossWeight"></td>
        </tr>

        <tr>
          <!-- remove button -->
          <td><button *ngIf="!disabled || removeItemEnabled" class="nrk-button" title="Remove item" (click)="onRemoveLineItem(idx)">-</button></td>

          <!-- public remark -->
          <td>
            <ngx-form-text [multiline]="1" [(value)]="item.publicRemark"  placeholder="Public remark" [disabled]="disabled"></ngx-form-text>
          </td>

          <!-- buttons: 'tranfer price to matrix' / 'open pfspo' / 'open oc report' -->
          <td>
            <div style="position:relative">
              <div style="position:absolute;left:2.2em;top:-1.5em;width:20em;text-align:left">
                <!-- <button *ngIf="!disabled && data.visibleMap.prices" style="width:12em" class="nrk-button" (click)="transferPrice(item)">
                  transfer price to matrix
                </button><br><br> -->
                <div class="row">
                  <a class="nrk-button pseudo-unlink" [routerLink]="['/pages/erp/reports']" [queryParams]="getPfspoReportParams(item)" target="_blank">open (PF)SPO report</a>
                  <button class="nrk-button mr-4" (click)="openPfspoAvailability(item, idx)">Availability</button>
                  <span *ngIf="data.visibleMap.prices && data.visibleMap.invoicePayment && isPartialPayment()">
                    <ngx-doc-form-texfield [(value)]="$any(item).invoicePercent" [styles]="{width:'2.5em'}" [disabled]="disabled"></ngx-doc-form-texfield>&nbsp;%
                  </span>
                </div>
                <div>
                  <button *ngIf="clipboardList?.length" [nbPopover]="clipboardBtn" class="nrk-button ml-1" style="pointer-events:initial;" title="copy selected text to clipboard">&#64;</button>
                  <ng-template #clipboardBtn>
                    <div class="p-4">
                      <h5>copy to clipboard</h5>
                      <div *ngFor="let text of clipboardList[idx]"><a [routerLink]="[]" (click)="onClipboardList(text); hidePopovers()">{{text}}</a></div>
                    </div>
                  </ng-template>
                  <button class="nrk-button ml-2" (click)="copyPackingToClipboard(idx)">&#64;DN</button>
                  <a class="nrk-button pseudo-unlink mt-1 ml-2" [routerLink]="['/pages/erp/reports']" [queryParams]="getOCReportParams(item)" target="_blank">open OC report</a>
                </div>
                <div *ngIf="!disabled">
                  <button class="nrk-button mt-1" title="update finished product" (click)="updateFinishedProduct(item)">update FP</button>
                </div>
                <div *ngIf="data.visibleMap.palletQty" class="row right mt-2">
                  <div class="mr-2">Pallet Qty:</div>
                  <div style="width:4rem;"><ngx-doc-form-texfield class="fullwidth" placeholder="Quantity" [(value)]="$any(item).palletQty" [disabled]="disabled">
                  </ngx-doc-form-texfield></div>
                  <div class="comment" *ngIf="calcPalletQty[idx]">&nbsp;&nbsp;(calc: {{calcPalletQty[idx]}})</div>
                </div>
              </div>
              <div *ngIf="!item?.position?.id" style="position:absolute;left:0.4;top:-1em;width:2em;text-align:center;">
                <span style="font-weight:bolder;font-size:large;border:1px solid;color:#f00a;padding:5px;">noID</span>
              </div>
            </div>
          </td>

          <td></td>
          <td colspan="2">
          </td>
          <!-- <td *ngIf="data.visibleMap.prices"></td> -->
          <td *ngIf="data.visibleMap.vat"></td>
          <td *ngIf="data.visibleMap.grossWeight"></td>
        </tr>

        <!-- date of delivery (order document) -->
        <tr>
          <td></td>
          <td>
            <div *ngIf="data.visibleMap.lineItemDateOfDelivery" class="row ml-2">
              <span [ngStyle]="{ 'color': item.dateOfDelivery ? 'inherit' : 'gray' }">{{docConfig.get('lineItemDateOfDelivery').label}}:&nbsp;</span>
              <ngx-doc-form-date class="fullwidth" [(value)]="$any(item).dateOfDelivery" [disabled]="disabled" (valueChange)="reloadFinishedProducts()"></ngx-doc-form-date>
            </div>
            <ngx-form-text [multiline]="1" [(value)]="item.adminText"  placeholder="Admin text" [disabled]="disabled"></ngx-form-text>
          </td>
          <td></td>
          <td></td>
          <td *ngIf="data.visibleMap.prices"></td>
          <td *ngIf="data.visibleMap.prices"></td>
          <td *ngIf="data.visibleMap.vat"></td>
          <td *ngIf="data.visibleMap.grossWeight"></td>
          <!-- <td *ngIf="!disabled"></td> -->
        </tr>

        <!-- OBIC: partial delivery -->
        <tr *ngIf="['OBIC'].includes(typeData.get(this.compilation.type).code)">
          <td></td>
          <td>Partial deliveries: {{obicSum}}</td>
        </tr>
        <tr *ngIf="['PFSPO', 'SPO'].includes(typeData.get(this.compilation.type).code) && obicSum">
          <td></td>
          <td>Delivery: {{obicNum}} / {{obicSum}}</td>
        </tr>

        <!-- order position / partial deliveries / Discount -->
        <tr *ngIf="data.visibleMap.lineItemOrderPos || data.readOnlyMap.lineItemOrderPos || ((data.visibleMap.discount && !isPartialPayment()))">
          <td></td>
          <td>
            <table><tr>
              <td class="text-left row">

                <!-- edit mode: order position / order position popup  -->
                <div class="nrk-v-middle" *ngIf="data.visibleMap.lineItemOrderPos">
                  <div class="mr-3">
                    <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poNum" [attr.disabled]="disabled || null" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item, $event, 'poNum')"/>
                    {{compilation?.customerDocumentNumber}}
                  </div>
                  <div *ngIf="item.position?.orderPos !== -2" class="d-flex">
                    <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poPos" [attr.disabled]="disabled || null" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item,$event, 'poPos')"/>
                    &nbsp;&nbsp;Pos:
                    <!-- <ngx-doc-form-texfield class="ml-1" [disabled]="disabled" [styles]="{width: '4rem'}"
                      [value]="tree.getItemOrderPos(item)" (valueChange)="setItemOrderPos(item, $event)"
                      [nbPopover]="disabled ? null : orderLineItemsRef"></ngx-doc-form-texfield> -->
                    <ngx-doc-form-texfield class="ml-1" [disabled]="disabled" [styles]="{width: '4rem'}"
                      [value]="tree.getItemOrderPos(item)"
                      [nbPopover]="disabled ? null : orderLineItemsRef"></ngx-doc-form-texfield>
                    <button *ngIf="item?.position && !disabled" class="nrk-doc-button mx-1" (click)="item.position.orderPos = -1" title="clear assigned Position">X</button>
                  </div>
                  <span *ngIf="item.position?.orderPos === -2" >Detached</span>
                  <button *ngIf="item?.position && !disabled && item.position.orderPos !== -2" class="nrk-doc-button mx-1" (click)="item.position.orderPos = -2" title="detach from Order">D</button>
                  <button *ngIf="item?.position && !disabled && item.position.orderPos === -2" class="nrk-doc-button mx-1" (click)="item.position.orderPos = -1" title="attach to Order">A</button>
                  <ng-template #orderLineItemsRef>
                    <div style="max-width:calc(100vw / 2)">
                      <table class="nrk-table nrk-row-select">
                        <tr><th>Pos</th><th>Finished product</th><th>Quantity</th><th>Unit</th><th>Price</th><th>Net</th></tr>
                        <ng-container *ngFor="let orderLi of orderLineItems; let olidx = index">
                          <tr (click)="setItemOrderPos(item, (olidx + 1) + '')">
                            <td>{{orderLi.position?.posOverride || (data.getPositionNumberFormat(this.compilation) | printf : olidx + 1)}}<!--{{olidx + 1}}--></td>
                            <td>{{orderLi.finishedProduct?.calcName}}</td>
                            <td>{{orderLi.displayUnitQuantity}}</td>
                            <td>{{unitData.get(orderLi.displayUnit).short}}</td>
                            <td>{{orderLi.displayUnitPrice | currency : compilation.currency : 'symbol' : '1.3-3' : 'de'}}</td>
                            <td>{{orderLi.quantity*orderLi.piecePrice | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}</td>
                          </tr>
                        </ng-container>
                      </table>
                    </div>
                  </ng-template>
                </div>

                <div class="mr-3"></div>

                <!-- order confirmation: partial delivery -->
                <div class="nrk-v-middle" *ngIf="data.visibleMap.lineItemOrderPos && item.position?.orderPos !== -2"> <!-- -2 === position detached from order -->
                  <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poDelivery" [attr.disabled]="disabled || null" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item, $event, 'poDelivery')"/>
                  <table class="partial-delivery-table"><tr>
                    <td>Delivery:</td>
                    <td [ngClass]="item.storedPartialDelivery?.num !== item.partialDelivery?.num && 'partial-delivery-mismatch' || ''">{{item.storedPartialDelivery?.num}}</td>
                    <td>/</td>
                    <td [ngClass]="item.storedPartialDelivery?.sum !== item.partialDelivery?.sum && 'partial-delivery-mismatch' || ''">{{item.storedPartialDelivery?.sum}}</td>
                  </tr><tr>
                    <td>Calculated:</td>
                    <td>{{item.partialDelivery?.num}}</td>
                    <td>/</td>
                    <td>{{item.partialDelivery?.sum}}</td>
                  </tr></table>
                </div>

                <!-- read only: order position / partial delivery -->
                <div class="nrk-v-middle" *ngIf="data.readOnlyMap.lineItemOrderPos && tree.linkedOC?.lineItems[idx]?.position?.orderPos !== -2">
                  <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poNum" [attr.disabled]="true" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item, $event, 'poNum')"/>
                  {{this.compilation?.customerDocumentNumber}};&nbsp;&nbsp;&nbsp;
                  <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poPos" [attr.disabled]="true" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item, $event, 'poPos')"/>
                  {{tree.linkedOC?.lineItems[idx]?.position?.orderPos >= 0 ? 'Pos: '+tree.getItemOrderPos(item)+';' : ''}}&nbsp;&nbsp;&nbsp;
                  <input style="width:1em" type="checkbox" [ngModel]="$any(item).poVisibility?.poDelivery" [attr.disabled]="true" title="show in PDF" (ngModelChange)="onPoVisibilityChanged(item, $event, 'poDelivery')"/>
                  {{tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum >= 0 ?
                    'Delivery: '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.num+' / '+tree.linkedOC?.lineItems[idx]?.partialDelivery?.sum : '' }}
                </div>

                <!-- <div class="ml-2 text-center">
                  <div><small class="text-muted">PDF</small></div>
                  <input style="width:1em" type="checkbox" [(ngModel)]="$any(item).posPDinPdf" [attr.disabled]="disabled || null" title="show in PDF"/>
                </div> -->

              </td>

              <!-- discount % -->
              <td *ngIf="data.visibleMap.discount && !isPartialPayment()" class="text-right">
                Discount:<ngx-doc-form-texfield class="ml-1" [maxlength]="3" [(value)]="$any(item).discount" [disabled]="disabled"></ngx-doc-form-texfield>&nbsp;%
              </td>
            </tr></table>
          </td>

          <ng-container  *ngIf="data.visibleMap.discount && !isPartialPayment()">

            <!-- discount quatity -->
            <td>
              <ngx-doc-form-texfield class="fullwidth right" placeholder="Quantity pcs" [mode]="'float'"
              [(value)]="$any(item).quantity" (valueChange)="recalc()" [disabled]="true"></ngx-doc-form-texfield>
            </td>

            <!-- discount unit (pc.) -->
            <td>
              <ngx-doc-form-texfield class="fullwidth center" value="pc." [disabled]="true">
              </ngx-doc-form-texfield>
            </td>

            <!-- discount piece price -->
            <td *ngIf="data.visibleMap.prices">
              <ngx-doc-form-texfield class="fullwidth right" placeholder="Price/pc" mode="currency" format="1.3-3" [currency]="compilation.currency"
                [value]="(item.piecePrice*((100-item.discount)/100)) + ''" [disabled]="true"></ngx-doc-form-texfield>
            </td>

            <!-- discount net -->
            <td *ngIf="data.visibleMap.prices" style="text-align:right">
              {{(item.quantity*item.piecePrice*((100-item.discount)/100)) | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>

            <!-- <td *ngIf="!disabled"></td> -->
          </ng-container>
          <td *ngIf="data.visibleMap.vat"></td>
          <td colspan="3" *ngIf="data.visibleMap.grossWeight"></td>
        </tr>

        <!-- HS code / OBIC / expiry date / partial payment -->
        <tr>
          <td></td>
          <td [attr.colspan]="(data.visibleMap.prices ? 6 : 5) + (disabled ? 0 : 1)" style="position:relative;left:-1em">
            <table class="hs-obic-exp">
              <tr>
                <td style="width: 80px">
                  HS Code:&nbsp;<input style="width:80px" type="text" [(ngModel)]="item.hsCode" placeholder="HS code" [attr.disabled]="disabled ? '' : null"/><br>
                  Country of Origin:&nbsp;<ngx-doc-form-filter-select 
                    [value]="item.countryOfOrigin || item.finishedProduct?.product?.countryOfOrigin || item.finishedProduct?.countryOfOrigin || undefined"
                    [options]="countryOptions"
                    [disabled]="disabled"
                    (valueChange)="item.countryOfOrigin = $event"
                  ></ngx-doc-form-filter-select>
                </td>
                <!-- <td style="width: 110px">
                  OBIC:&nbsp;<input style="width:110px" type="text" [(ngModel)]="item.tbCode" (ngModelChange)="onObicChanged()" placeholder="OBIC" [attr.disabled]="disabled || (compilation.type !== typeData.get('OBIC').id && tree.linkedObic) ? '' : null"/>
                </td> -->
                <td style="width: 110px" *ngIf="['OBIC'].includes(typeData.get(compilation.type).code)">
                  OBIC:&nbsp;<input style="width:110px" type="text" [(ngModel)]="item.tbCode" (ngModelChange)="onObicChanged()" placeholder="OBIC" [attr.disabled]="disabled || (compilation.type !== typeData.get('OBIC').id && tree.linkedObic) ? '' : null"/>
                </td>
                <ng-container *ngIf="boxBlockValues[idx] && (data.visibleMap.lineItemBoxEditBlock || data.visibleMap.lineItemBoxReadOnlyBlock)">
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0 1px 1px;width:8.5rem">
                    <div><input style="width:1em" type="checkbox" [(ngModel)]="$any(item).tcChecked" [attr.disabled]="disabled || null" title="show in PDF"/></div>
                    OBIC:&nbsp;{{obicCodes[idx]}}
                      <input *ngIf="data.visibleMap.lineItemBoxEditBlock" type="text" [(ngModel)]="item.tbCode" placeholder="OBIC" [attr.disabled]="disabled || null"/>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('tbCode', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].tbCode}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0;width:9rem">
                    <!-- <div><input style="width:1em" type="checkbox" [ngModel]="$any(item).tcChecked" (change)="toggleShowLineItemTCinPdf(item)" [attr.disabled]="disabled || null"/></div> -->
                    <br>Factory Order #:&nbsp;
                      <input *ngIf="data.visibleMap.lineItemBoxEditBlock" type="text" [(ngModel)]="item.factoryOrderNumber" placeholder="Factory Order #" [attr.disabled]="disabled || null"/>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('factoryOrderNumber', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].factoryOrderNumber}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0;width:6rem">
                    <br>TC #:&nbsp;
                      <input *ngIf="data.visibleMap.lineItemBoxEditBlock" type="text" ngModel="" placeholder="Number of TC" [attr.disabled]="true"/>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('numberOfTC', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].numberOfTC}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0;width:8rem">
                    <br>TC Date:&nbsp;
                      <ngx-doc-form-date *ngIf="data.visibleMap.lineItemBoxEditBlock" class="fullwidth" [value]="null" [disabled]="true"></ngx-doc-form-date>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('dateOfTC', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].dateOfTC}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0;">
                    <br>Prod Date (min):&nbsp;
                      <ngx-doc-form-date *ngIf="data.visibleMap.lineItemBoxEditBlock" class="fullwidth" [value]="null" [disabled]="true"></ngx-doc-form-date>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('minProdDate', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].minProdDate}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 0;">
                    <br>Prod Date (max):&nbsp;
                      <ngx-doc-form-date *ngIf="data.visibleMap.lineItemBoxEditBlock" class="fullwidth" [value]="null" [disabled]="true"></ngx-doc-form-date>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('maxProdDate', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].maxProdDate}}</div>
                  </td>
                  <td style="border-style:solid;border-color:lightgray;border-width: 1px 1px 1px 0;">
                    <br>Expiry Date:&nbsp;
                    <!-- <input style="max-width:90px" [(ngModel)]="item.expiryDate" placeholder="Expiry date" [nbDatepicker]="expDate" [attr.disabled]="disabled ? '' : null"> -->
                    <!-- <ngx-datepicker-patch #expDate (dateChange)="item.expiryDate = $event" format="yyyy-MM-dd" [date]="item.expiryDate"></ngx-datepicker-patch> -->
                      <ngx-doc-form-date *ngIf="data.visibleMap.lineItemBoxEditBlock" class="fullwidth" 
                        [(value)]="$any(item).expiryDate"
                        [disabled]="disabled">
                      </ngx-doc-form-date>
                      <!-- <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{getBoxBlockValues('expiryDate', idx)}}</div> -->
                      <div *ngIf="data.visibleMap.lineItemBoxReadOnlyBlock" class="box-block">{{boxBlockValues[idx].expiryDate}}</div>
                  </td>
                </ng-container>
              </tr>
            </table>
          </td>
          <!-- <td></td>
          <td></td> -->
          <!-- <td *ngIf="data.visibleMap.prices"></td> -->
          <!-- <td *ngIf="data.visibleMap.prices">
          </td> -->
          <!-- <td *ngIf="data.visibleMap.prices"></td> -->
          <!-- <td *ngIf="data.visibleMap.vat" colspan="2">
            <span *ngIf="data.visibleMap.invoicePayment && isPartialPayment()">
              <ngx-doc-form-texfield [(value)]="$any(item).invoicePercent" [styles]="{width:'2.5em'}" [disabled]="disabled"></ngx-doc-form-texfield>&nbsp;%
            </span>
          </td>
          <td *ngIf="data.visibleMap.grossWeight" colspan="2"></td> -->
          <!-- <td *ngIf="!disabled"></td> -->
        </tr>

        <tr *ngIf="item.finishedProduct?.customerProductSpecification?.length">
          <td></td>
          <td colspan="100">
            <span><input style="width:1em" 
              type="checkbox" 
              [(ngModel)]="item.showCustomerProductSpecification"
              [attr.disabled]="disabled || null" title="show in PDF"/>&nbsp;&nbsp;&nbsp;
            </span>
            <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.comment">
              <span style="color:gray;margin-right:1em">Customer product specification:</span> {{item.finishedProduct.customerProductSpecification[0]?.comment}}
            </span>
            <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.additionalField">
              <span style="color:gray;margin:0 1em">Revision:</span> {{item.finishedProduct.customerProductSpecification[0]?.additionalField}}
            </span>
            <span *ngIf="item.finishedProduct.customerProductSpecification[0]?.additionalDate">
              <span style="color:gray;margin:0 1em">Date of release:</span> {{item.finishedProduct.customerProductSpecification[0]?.additionalDate | date : 'yyyy-MM-dd'}}
            </span>
          </td>
        </tr>
        <ng-container *ngIf="item.finishedProduct?.content?.energy 
          && !item.finishedProduct.customerProductSpecification?.length 
          && ['OR', 'OC'].includes(typeData.get(compilation.type).code)">
          <tr>
            <td></td>
            <td colspan="100">
              <div class="row">
                <!-- <div><ngx-doc-form-checkbox [(value)]="item.finishedProduct.showMissingCpsWarning" [disabled]="disabled"></ngx-doc-form-checkbox></div> -->
                <div style="color:gray">No customer specification available</div>
              </div>
            </td>
          </tr>
        </ng-container>


        <!-- associated PFSPOs -->

        <tr *ngIf="data.visibleMap.associatedPfspo && (getOCItem(item)?.pfspo?.length || (!disabled && getOCItem(item)?.pfspo))">
          <td colspan="100" class="related-ocs nrk-smaller-font">
            <div class="d-flex justify-content-between">
              <div>Associated (PF)SPOs</div>
              <div style="width: 45em; text-align: right">
                <!-- {{getSumAssignedQ(getOCItem(item)) === getSumAssignedBoxes(idx)}}--{{getSumAssignedQ(getOCItem(item))}}--{{getSumAssignedBoxes(idx)}} -->
                <div [ngStyle]="{ 
                  display: 'inline-block',
                  border: item.quantity === getSumAssignedBoxes(idx) && getSumAssignedQ(getOCItem(item)) === getSumAssignedBoxes(idx) ? 'none' :'3px solid red',
                  padding: '2px 1rem 0 1rem'
                }">
                  <b class="mr-2">Line Item Q:</b>{{item.quantity}}
                  <b class="ml-3 mr-2">Σ Assigned Q:</b>{{getSumAssignedQ(getOCItem(item))}}
                  <b class="ml-3 mr-2">Δ:</b>{{item.quantity - getSumAssignedQ(getOCItem(item))}}
                  <b class="ml-3 mr-2">Σ Assigned boxes:</b>{{getSumAssignedBoxes(idx)}}
                </div>
              </div>
            </div>
            <table class="nrk-table">
              <tr *ngIf="tree.isLoading"><td colspan="100"><ngx-loading-spinner [loading]="tree.isLoading"></ngx-loading-spinner></td></tr>
              <ng-container *ngIf="!tree.isLoading">
                <tr>
                  <th *ngIf="!disabled && !data.readOnlyMap.associatedPfspo" class="related-ocs">
                    <button class="nrk-doc-button" (click)="assignPFSPO(getOCItem(item), idx)">+</button>
                    <div style="position:relative">
                      <div style="position:absolute;bottom:0;left:11rem">
                        <button class="nrk-doc-button" (click)="this.tree.synchronizeSharedFields(this.compilation)">⟳</button>
                      </div>
                    </div>
                  </th>
                  <th *ngFor="let conf of assignedPfsposConfig" class="related-ocs">{{conf.name}}</th>
                  <th>Boxes</th>
                </tr>
                <tr *ngFor="let spo of item.pfspo; index as spoIdx">
                  <td style="text-align:center" *ngIf="!tree.isLoading && !disabled && !data.readOnlyMap.associatedPfspo">
                    <button class="nrk-doc-button" (click)="removePFSPO(item, spo, idx)">-</button>
                  </td>
                  <!-- <td>{{oc.code}}</td> -->
                  <!-- <td>{{spo.parentPos+1}}</td> -->
                  <td><a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(spo.code)]"
                    [queryParams]="{code: spo.code}" >{{$any(spo) | documentNumber}}</a>
                    <div *ngIf="associatedCS[spo.code]"><a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(spo.code)]"
                    [queryParams]="{code: associatedCS[spo.code].code}" >{{$any(associatedCS[spo.code]) | documentNumber}}</a></div>
                  </td>
                  <td style="text-align:center">{{spo.pos}}</td>
                  <td [ngStyle]="deliveryValid(getOCItem(item).pfspo)">{{spo.doc?.directDelivery ? 'direct' : 'indirect'}}</td>
                  <td>{{spo.docLineItem?.displayUnitQuantity}}</td>
                  <td style="text-align:center">{{unitData.get(spo.docLineItem?.displayUnit)?.short}}</td>
                  <td>{{spo.docLineItem?.quantity}}</td>
                  <!-- <td>{{spo.doc.readyForPickupDate | date : 'yy-MM-dd'}}</td> -->
                  <td style="text-align:center">{{spo.doc?.exwJapanDate | date : 'yy-MM-dd'}}<br>{{spo.doc?.arrivingVieDate | date : 'yy-MM-dd'}}</td>
                  <td style="text-align:center">{{spo.doc?.vieDispatchDate | date : 'yy-MM-dd'}}<br>{{spo.doc?.etaCustomerDate | date : 'yy-MM-dd'}}</td>
                  <td style="text-align:center">{{spoStatusData.get(spo.doc?.transportRun?.spoStatus)?.name}}</td>
                  <td style="text-align:center">{{transportStatusData.get(spo.doc?.transportRun?.transportStatus)?.name}}</td>
                  <!-- <td>{{spo.quantity}}</td> -->
                  <td style="width:8rem"><ngx-doc-form-texfield  class="fullwidth" [mode]="'integer'" [(value)]="$any(spo).quantity" [disabled]="disabled || data.readOnlyMap.associatedPfspo"></ngx-doc-form-texfield></td>
                  <!-- <td *ngIf="!disabled && !data.readOnlyMap.associatedPfspo && compilation.type === typeData.get('OC').id"> -->
                  <td class="text-center">

                    <ng-container *ngIf="expiryData && expiryData[idx] && expiryData[idx][spo?.code]?.warningText">
                      <div class="expiry-warning" *ngIf="!data.areBoxesLoading && spoBoxes && spoBoxes[idx] && spoBoxes[idx][spo?.code]?.length">
                        <div class="expiry-block">
                          <button class="btn btn-sm btn-danger" (click)="expiryWarning.toggle()">!</button>
                        </div>
                        <nrk-window #expiryWarning>
                          <nrk-header>Expiry Warning</nrk-header>
                          <nrk-content>
                            <div style="background-color: #f00a;padding:0.5rem;margin:1rem">{{expiryData[idx][spo.code]?.warningText}}</div>
                            <table>
                              <tr><td>Oldest Production Date</td><td>{{expiryData[idx][spo.code]?.oldestProductionDate | date : 'yyyy-MM-dd'}}</td></tr>
                              <tr><td>Newest Production Date</td><td>{{expiryData[idx][spo.code]?.newestProductionDate | date : 'yyyy-MM-dd'}}</td></tr>
                              <tr><td>Dispatch Date</td><td>{{this.compilation.vieDispatchDate | date : 'yyyy-MM-dd'}}</td></tr>
                              <tr><td>Expiry Months at Lowest Temperature</td><td>{{expiryData[idx][spo.code]?.expiryMonthsAtLowestTemp}}</td></tr>
                              <tr>
                                <td>Min Remaining Shelf Life at Dispatch Date</td>
                                <td>{{expiryData[idx][spo.code]?.minRemainingShelfLifeAtDispatch}} days ({{expiryData[idx][spo.code]?.minRemainingShelfLifeAtDispatchMonths | ngxRound : 2}}) months</td>
                              </tr>
                            </table>
                            <table>
                              <tr><td>
                                <button class="nrk-button my-2" style="pointer-events:initial;" title="copy text to clipboard" (click)="expiryClipboardText(idx, expiryData, spo, true)">&#64;</button>                            
                              </td><td>
                                <div style="width:30rem;text-align:left">{{expiryClipboardText(idx, expiryData, spo)}}</div>                            
                              </td></tr>
                            </table>
                          </nrk-content>
                          <nrk-footer><button class="btn btn-sm btn-default" (click)="expiryWarning.close()">Close</button></nrk-footer>
                        </nrk-window>
                      </div>
                    </ng-container>

                    <ngx-box-selection *ngIf="spoBoxes" [compilation]="compilation" [spoBoxes]="spoBoxes" [disabled]="disabled" [lineItemContainer]="this" [idx]="idx" [item]="item" [spoIdx]="spoIdx" [associatedCS]="associatedCS" (setBoxBlockLines)="setBoxBlockLines($event)"></ngx-box-selection>
                  </td>
                </tr>
              </ng-container>
            </table>
          </td>
        </tr>

   

        <!-- order: associated PFSPOs collected from order confirmations -->

        <tr *ngIf="compilation.type === 2 && associatedOCPfspos && associatedOCPfspos[idx] && associatedOCPfspos[idx].length">
          <td colspan="100" class="related-ocs nrk-smaller-font" style="font-size:0.9rem">
            Associated OC (PF)SPOs
            <table class="nrk-table">
              <tr><th *ngFor="let conf of assignedOCPfsposConfig">{{conf.name}}</th></tr>
              <tr *ngFor="let doc of associatedOCPfspos[idx]; let spoidx = index">
                <td><a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(doc.oc.code)]"
                  [queryParams]="{code: doc.oc.code}" >{{doc.oc | documentNumber}}</a></td>
                <!-- <td>{{doc.spo.parentPos+1}}|{{doc.ocpos+1}}</td> -->
                <td>{{doc.spo.parentPos+1}}</td>
                <td><a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(doc.spo.code)]"
                  [queryParams]="{code: doc.spo.code}" >{{$any(doc.spo) | documentNumber}}</a></td>
                <td>{{doc.spo.pos}}</td>
                <td [ngStyle]="deliveryValid(associatedOCPfspos[idx])">{{doc.spo.doc?.directDelivery ? 'direct' : 'indirect'}}</td>
                <td>{{doc.spo.docLineItem?.displayUnitQuantity}}</td>
                <td>{{unitData.get(doc.spo.docLineItem?.displayUnit)?.short}}</td>
                <!-- <td>{{spo.doc.readyForPickupDate | date : 'yy-MM-dd'}}</td> -->
                <td>{{doc.spo.docLineItem?.quantity}}</td>
                <td>{{doc.spo.doc?.exwJapanDate | date : 'yy-MM-dd'}}<br>{{doc.spo.doc?.arrivingVieDate | date : 'yy-MM-dd'}}</td>
                <td>{{doc.spo.doc?.vieDispatchDate | date : 'yy-MM-dd'}}<br>{{doc.spo.doc?.customerAcceptedDeliveryDate | date : 'yy-MM-dd'}}</td>
                <td>{{spoStatusData.get(doc.spo.doc?.transportRun?.spoStatus)?.name}}</td>
                <td>{{transportStatusData.get(doc.spo.doc?.transportRun?.transportStatus)?.name}}</td>
                <td>{{doc.spo.quantity}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <!-- SPO, PFSPO: associated order confirmations -->

        <tr *ngIf="[4,6].includes(compilation.type) && item.relatedOCs && item.relatedOCs.length"> <!-- in (PF)SPO -->
          <td colspan="100" class="related-ocs nrk-smaller-font">
            <!-- Associated Order Confirmations -->
            <ngx-pfspo-availability
              [compilation]="compilation"
              [lineItem]="item"
              [spoPosition]="idx"
              [disabled]="disabled"

            ></ngx-pfspo-availability>
            <!-- <table class="spo-quantities">
              <tr>
                <th>Delivered Q: <span>{{getDeliveredQ(item)}}</span></th>
                <th>Σ Assigned Q: <span>{{getAssignedQ(item)}}</span></th>
                <th>Available Q: <span>{{getAvailableQ(item)}}</span></th>
                <th>Free Q: <span>{{getFreeQ(item)}}</span></th>
              </tr>
            </table>
            <table class="nrk-table">
              <tr>
                <th *ngIf="!disabled" style="text-align:center">
                  <ngx-document-oc-selector
                    [style]="{'left':'-5em','width':'75em'}"
                    [filters]="[{'id':'productCode', 'search':item.finishedProduct?.calcCode}]"
                    (compilationChange)="onOcSelected(item, idx, $event)"
                  ></ngx-document-oc-selector>
                <th *ngIf="!disabled" title="mark OC completely invoiced">INV</th>
                <th>OC#</th>
                <th style="text-align:center">OC Pos</th>
                <th style="text-align:right" title="OC line item quantity">Q</th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Dispatch date</th>
                <th style="text-align:center">ETA customer</th>
                <th style="text-align:center" title="customer desired delivery date">CRDD</th>
                <th style="text-align:center" title="customer accepted delivery date">CADD</th>
                <th style="text-align:right" title="assigned quantity">Assigned Q</th>
              </tr>
              <tr *ngFor="let oc of item.relatedOCs; let lidx = index">
                <td *ngIf="!disabled" style="text-align:center"><button class="nrk-doc-button" (click)="removeOC(item, lidx, idx)">-</button></td>
                <td *ngIf="!disabled" style="padding-left:0.8rem"><ngx-doc-form-checkbox [value]="oc.doc.completelyInvoiced" 
                  (valueChange)="toggleCompletelyInvoiced(oc.doc, $event)"></ngx-doc-form-checkbox></td>
                <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
                  [queryParams]="{code: oc.doc.code}" >{{oc.doc | documentNumber}}</a></td>
                <td style="text-align:center">{{oc.pos}}</td>
                <td style="text-align:right">{{oc.doc.lineItems[oc.pos-1]?.displayUnitQuantity}}</td>
                <td style="text-align:center">{{unitData.get(oc.doc.lineItems[oc.pos-1]?.displayUnit)?.short}}</td>
                <td style="text-align:center">{{oc.doc.vieDispatchDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:center">{{oc.doc.etaCustomerDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:center">{{oc.doc.customerRequestedDeliveryDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:center">{{oc.doc.customerAcceptedDeliveryDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:right;padding-right:2em">{{oc.quantity}}</td>
              </tr>
            </table> -->
          </td>
        </tr>

        <tr *ngIf="data.visibleMap.boxDetails"> <!-- in (PF)SPO -->
          <td colspan="100" class="related-ocs nrk-smaller-font">
            <!-- <ngx-box-details *ngIf="!disabled || item.boxDetails?.length" [compilation]="compilation" [lineItem]="item" [disabled]="disabled"></ngx-box-details> -->

            <ngx-box-details [compilation]="compilation" [lineItem]="item" [disabled]="disabled"></ngx-box-details>

            <ngx-box-selection  *ngIf="spoBoxes" [compilation]="compilation" [spoBoxes]="spoBoxes" [disabled]="disabled" [lineItemContainer]="this" [idx]="idx" [item]="item" [docCode]="compilation.code" [associatedCS]="associatedCS" (setBoxBlockLines)="setBoxBlockLines($event)"></ngx-box-selection>

          </td>
        </tr>

      </tbody>

      <!-- subtotal net / partial paymnet / discount -->

      <ng-container *ngIf="!optional">
        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none">
          <tr>
            <td colspan="2"></td>
            <td colspan="3" [ngClass]="{'li-border-left':1, 'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
              style="text-align:right">Line items subtotal:</td>
            <td [ngClass]="{'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
              style="text-align:right">{{subTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
              <div *ngIf="subTotal !== calculatedSubTotal" class="calculated-price" style="top:0.5em"><div>{{calculatedSubTotal | ngxRound : 10}}</div></div>
            </td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right" ></td>
          </tr>
          <tr *ngIf="data.visibleMap.invoicePayment && isPartialPayment()">
            <td colspan="2"></td>
            <td colspan="3" class="li-border-left li-border-bottom" style="text-align:right">{{getInvoicePercentText()}} Line items subtotal:</td>
            <td class="li-border-bottom" style="text-align:right">{{partialSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right" ></td>
          </tr>
          <tr *ngIf="data.visibleMap.discount && isDiscount()">
            <td colspan="2"></td>
            <td colspan="3" class="li-border-left li-border-bottom" style="text-align:right">Discounted subtotal:</td>
            <td class="li-border-bottom" style="text-align:right">{{discountedSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right" ></td>
          </tr>
        </tbody>

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>

        <tbody style="background-color:transparent;">
          <tr>
            <td colspan="100" style="padding:0;margin:0">
              <table>
                <tr>
                  <td><b>Total Quantity:</b></td>
                  <td style="text-align:right">{{totalQuantity.pc | number : '1.0-0' : 'de'}}</td><td>pc</td>
                  <td style="text-align:right">{{totalQuantity.m2 | number : '1.0-2' : 'de'}}</td><td>m²</td>
                  <td style="text-align:right">{{totalQuantity.m | number : '1.0-2' : 'de'}}</td><td>m</td>
                  <td style="text-align:right">{{totalQuantity.kg | number : '1.0-2' : 'de'}}</td><td>kg</td>
                </tr>
              </table>
            </td>
          </tr>
        <tbody>

        <tbody style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>

        <!-- deductible items  header -->
        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;">
          <tr>
            <th colspan="100" style="padding:0;margin:0">
              <table>
                <tr>
                  <th *ngIf="!disabled && vatItems?.length == 1" style="width:2rem;padding:0.5rem"><button class="nrk-button" alt="Add position" title="Add other Item" (click)="onNewDeductibleItem()">+</button></th>
                  <th style="width:2rem;padding:0.5rem">Pos</th>
                  <th style="text-align:left;width:30rem" >Other Items</th>
                  <th style="text-align:left;width:29rem" >Base Product</th>
                  <th style="text-align:right">NET</th>
                  <th *ngIf="data.visibleMap.vat">VAT%</th>
                  <th *ngIf="!disabled"></th>
                </tr>
              </table>
            </th>
          </tr>
        <tbody>

        <!-- deductible items -->
        <tbody *ngIf="data.visibleMap.prices" class="vat">
          <tr><td colspan="100">
            <table>
              <tr *ngFor="let item of deductibleItems; let idx = index; last as isLast" [ngClass]="vatItems?.length != 1 ? 'vat-highlight' : null">
                <!-- remove button -->
                <td *ngIf="!disabled" style="width:2em"><button class="nrk-button" title="Remove other item" (click)="onRemoveDeductibleItem(idx)">-</button></td>

                <td style="text-align:center">{{ compilation.lineItems?.length + idx + 1 | nrkPad : 2 }}</td>

                <!-- description -->
                <td style="text-align:left; width:30em">
                  <div class="row">
                    <div style="width:calc(100% - 4rem);margin-left:1rem"><ngx-form-text class="fullwidth" [multiline]="1" placeholder="Description" [(value)]="item.description" [disabled]="disabled"></ngx-form-text></div>
                    <div style="margin-top: 0.3rem"><button class="nrk-button ml-2" [nbPopover]="deductibleSelection">☰</button></div>
                  </div>
                  <ng-template #deductibleSelection>
                    <div class="p-3">
                      <table class="nrk-table nrk-row-select">
                        <tr><th>INV #</th><th>Payment</th><th>Issue date</th><th class="text-right">Net</th></tr>
                        <tr *ngFor="let inv of this.tree.paymentPlanInvoiceData.treeInvoices" (click)="setDeductibleText(item, inv)">
                          <td>{{inv.doc.code}}</td>
                          <td>{{inv.payment}}</td>
                          <td>{{inv.issueDate}}</td>
                          <td class="text-right">{{inv.totalNet | currency : inv.doc.currency : 'symbol' : '1.2-2' : 'de'}}</td>
                        </tr>
                      </table>
                    </div>
                  </ng-template>
                </td>

                <!-- base product -->
                <td style="width:24em">
                  <ngx-form-column-select title="Base Product" [textfield]="true" [baseProduct]="true" (productSelected)="item.baseProduct = $event.baseCode" [value]="item.baseProduct"
                    [disabled]="disabled" [initialProducts]="getLineItemProducts()"></ngx-form-column-select>
                </td>

                <!-- amount value -->
                <td style="text-align:right">
                  <ngx-doc-form-texfield class="fullwidth right" placeholder="Amount" [mode]="'currency'"
                    [(value)]="$any(item).value" (valueChange)="recalc()" [disabled]="disabled"></ngx-doc-form-texfield>
                </td>

                <!-- VAT -->
                <td *ngIf="data.visibleMap.vat" style="text-align: center;width:3em">{{compilation.vatGlobal}}</td>

                <!-- move handles -->
                <td *ngIf="!disabled">
                  <table>
                    <tr>
                      <td *ngIf="idx == 0" class="moveItemDisabled">▲</td>
                      <td *ngIf="idx !== 0" class="moveItem" (click)="onMoveDeductibleItem(idx, true)">▲</td>
                    </tr>
                    <tr>
                      <td *ngIf="isLast" class="moveItemDisabled">▼</td>
                      <td *ngIf="!isLast"class="moveItem" (click)="onMoveDeductibleItem(idx, false)">▼</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td></tr>
        </tbody>

        <tbody style="background-color:transparent;border:none">
          <tr>
            <td colspan="2"></td>
            <td colspan="3" [ngClass]="{'li-border-left':1, 'li-border-bottom':1}"
              style="text-align:right">Deductables subtotal:</td>
            <td [ngClass]="{'li-border-bottom':1}"
              style="text-align:right">{{deductibleTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
            </td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right"></td>
          </tr>
        </tbody>

        <!-- line items summary (net total / partaial payment / discount) -->
        <!-- <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none">
          <tr>
            <td colspan="3"></td>
            <td colspan="2" [ngClass]="{'li-border-left':1, 'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
              style="text-align:right">Net total:</td>
            <td [ngClass]="{'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
              style="text-align:right">{{netTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
            </td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right"></td>
          </tr>
          <tr *ngIf="data.visibleMap.invoicePayment && isPartialPayment()">
            <td colspan="3"></td>
            <td colspan="2" class="li-border-left li-border-bottom" style="text-align:right">{{getInvoicePercentText()}} net total:</td>
            <td class="li-border-bottom" style="text-align:right">{{partialNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right"></td>
          </tr>
          <tr *ngIf="data.visibleMap.discount && isDiscount()">
            <td colspan="3"></td>
            <td colspan="2" class="li-border-left li-border-bottom" style="text-align:right">Discounted net total:</td>
            <td class="li-border-bottom" style="text-align:right">{{discountedNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
            <td class="li-border-bottom li-border-right"></td>
          </tr>
        </tbody> -->

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>
        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"></tbody>

        <!-- --------------- payment plan invoices ---------------------- -->

        <ng-container *ngIf="data.visibleMap.paymentPlanInvoice">
          <tbody>
            <tr>
              <td colspan="100">
                <ngx-payment-plan-invoices #ppInv [compilation]="compilation" [disabled]="disabled"></ngx-payment-plan-invoices>
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="data.visibleMap.prices && viewReady && ppInv?.hasInvoices" style="background-color:transparent;border:none">
            <tr>
              <td colspan="2"></td>
              <td colspan="3" [ngClass]="{'li-border-left':1, 'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
                style="text-align:right">Progress payment subtotal:</td>
              <td [ngClass]="{'li-border-bottom':1}"
                style="text-align:right">{{ppInvoicesTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
              </td>
              <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
              <td class="li-border-bottom li-border-right"></td>
            </tr>
          </tbody>
          <!-- <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none">
            <tr>
              <td colspan="3"></td>
              <td colspan="2" [ngClass]="{'li-border-left':1, 'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
                style="text-align:right">Net total:</td>
              <td [ngClass]="{'li-border-bottom':1, 'gray-italic':isPartialPayment()}"
                style="text-align:right">{{ppNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
              </td>
              <td class="li-border-bottom" *ngIf="data.visibleMap.vat && !disabled"></td>
              <td class="li-border-bottom li-border-right"></td>
            </tr>
          </tbody> -->
        </ng-container>

        <!-- --------------- end payment plan invoices ---------------------- -->

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>

        <!-- --------------- summary ---------------------- -->

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;page-break-inside: avoid;">
          <tr class="summary-payment-item">
            <td colspan="2"></td>
            <td colspan="3" style="text-align:right">Line items subtotal:</td>
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right">{{calculatedSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isPartialPayment()" style="text-align:right">{{partialSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right">{{discountedSubTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
          <tr class="summary-payment-item" *ngIf="deductibleItems?.length">
            <td colspan="2"></td>
            <td colspan="3" style="text-align:right">Deductibles items subtotal:</td>
            <td style="text-align:right">{{deductibleTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
          <tr class="summary-payment-item" *ngIf="!tree.isLoading && ppInv?.hasInvoices">
            <td colspan="2"></td>
            <td colspan="3" style="text-align:right">Progress payment subtotal:</td>
            <td style="text-align:right">{{ppInvoicesTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
          <tr class="summary-payment-total">
            <td colspan="2"></td>
            <td colspan="3" style="text-align:right">Total net:</td>
            <!-- <td style="text-align:right">{{ppNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td> -->
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right">{{ppNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isPartialPayment()" style="text-align:right">{{ppPartialNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right">{{ppDiscountedNetTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
        </tbody>

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>

        <!-- VAT summary header-->
        <tbody *ngIf="data.visibleMap.vat" style="background-color:transparent;">
          <tr>
            <th></th>
            <th colspan="1" style="text-align:left">VAT %</th>
            <th colspan="3" style="text-align:right">Liable to VAT</th>
            <th colspan="1" style="text-align:right">VAT</th>
            <th *ngIf="data.visibleMap.vat"></th>
            <th *ngIf="!disabled"></th>
          </tr>
        </tbody>

        <!-- VAT summary -->
        <ng-container *ngIf="data.visibleMap.vat">
          <tbody class="vat" *ngFor="let item of vatItems">
            <tr>
              <td></td>
              <td colspan="1" style="text-align:left">VAT {{item.vat}}%</td>
                <td *ngIf="!isPartialPayment() && !isDiscount()" colspan="3" style="text-align:right">
                  {{item.sum | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isPartialPayment()" colspan="3" style="text-align:right">
                  {{item.partialVat | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isDiscount()" colspan="3" style="text-align:right">
                  {{item.discountedVat | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                
                <td *ngIf="!isPartialPayment() && !isDiscount()" colspan="1" style="text-align:right">
                  {{item.sum * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isPartialPayment()" colspan="1" style="text-align:right">
                  {{item.partialVat * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                <td *ngIf="isDiscount()" colspan="1" style="text-align:right">
                  {{item.discountedVat * item.vat / 100 | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>

                <td *ngIf="data.visibleMap.vat && !disabled"></td>
              <td></td>
            </tr>
          </tbody>
        </ng-container>

        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;border:none"><tr><td>&nbsp;</td></tr></tbody>

        <!-- payment summary (VAT / net total) -->
        <tbody *ngIf="data.visibleMap.prices" style="background-color:transparent;page-break-inside: avoid;">
          <tr class="vat-total" *ngIf="data.visibleMap.vat">
            <td colspan="3">            
              <div style="position:relative; left:70em; bottom: 3em" *ngIf="['OF'].includes(typeData.get(compilation.type)?.code)">
                <div style="position: absolute">
                  <ngx-line-item-info-box [compilation]="compilation" [summary]="true"></ngx-line-item-info-box>
                </div>
              </div>
            </td>
            <td colspan="2" style="text-align:right">VAT total:</td>
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right">{{vatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isPartialPayment()" style="text-align:right">{{partialVatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right">{{discountedVatTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
          <tr class="total-payment">
            <td colspan="3"></td>
            <td colspan="2" style="text-align:right">{{compilation.type === 8 ? 'Total credit:' : 'Total to be paid:'}}</td>
            <td *ngIf="!isPartialPayment() && !isDiscount()" style="text-align:right">
              {{sumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}
              <div *ngIf="sumTotal !== calculatedTotal" class="calculated-price" style="top:0.5em"><div>{{calculatedTotal | ngxRound : 10}}</div></div>
            </td>
            <td *ngIf="isPartialPayment()" style="text-align:right">{{partialSumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="isDiscount()" style="text-align:right">{{discountedSumTotal | currency : compilation.currency : 'symbol' : '1.2-2' : 'de' }}</td>
            <td *ngIf="data.visibleMap.vat"></td>
            <td *ngIf="!disabled"></td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>
</div>

<!-- product wizard (generate product via lie item 'gen' button) -->
<!-- <ngx-product-wizard
  [productWizard]="true"
  [(show)]="showWizard" 
  [compilation]="compilation"
  (onFinishedProduct)="onProductSelected(index, { id: $event })"
  (onFinishedProducts)="onProductsSelected($any($event))"
  (onClose)="onWizardClosed()"
></ngx-product-wizard> -->

<ngx-product-wizard
  [productWizard]="true"
  [(show)]="showWizard" 
  [compilation]="compilation"
  (onFinishedProduct)="onProductSelected(index, $event)"
  (onFinishedProducts)="onProductsSelected($any($event))"
  (onClose)="onWizardClosed()"
></ngx-product-wizard>

<div *ngIf="generatingFinishedProducts" class="gen-fp">
  <div><ngx-loading-spinner [loading]="true" label=""></ngx-loading-spinner></div>
</div>
